<button id="app-help" type="button" class="btn btn-{{class}}" placement="left" container="body" [ngbTooltip]="'ui.help-tooltip'|translate"
  (click)="click(); $event.stopPropagation()"><i class="far fa-question-circle"></i></button>